import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { I18nHelperService } from '@xref/ngx';
import moment from 'moment';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'xqnr-footer',
  templateUrl: './footer.component.pug',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {
  moment: any;
  contrast = false;
  checkedTranslationId = 'footer.switch.contrastOn';
  domain = environment.DOMAIN;

  constructor(
    private i18nHelper: I18nHelperService
  ) { }

  ngOnInit() {
    this.moment = moment;
    this.i18nHelper.addMoment(this.moment);
  }
}
